// Modules
import React from "react";

// Components
import ResortDropdownGroup from './ResortDropdownGroup'

type Props = {
    resortList: any[];
    onSelect: any;
    onRemoval: any;
    selected: string[];
    limit: number;
}

type ItemRefs = {[key: string]:HTMLElement};

class ResortDropdownList extends React.Component<Props, ItemRefs, {}> {
  itemRefs:ItemRefs = {};

  constructor(props:Props) {
    super(props);
    this.keydown = this.keydown.bind(this);
    this.setItemRef = this.setItemRef.bind(this);
  }

  keydown(itemKey: string, event: React.KeyboardEvent<HTMLElement>) {

    const itemRefsKeys = Object.keys(this.itemRefs);
    const activeIndex = itemRefsKeys.indexOf(itemKey);

    let target: HTMLElement;

    // don't prevent default for tab
    if (event.keyCode !== 9) {
      event.preventDefault();
    }

    switch (event.keyCode) {
        // down arrow
        case 40:
          // on last item, can't go down
          if (activeIndex + 1 === itemRefsKeys.length) {
            return;
          }
          const nextIndex = activeIndex + 1;
          const nextItemRef = itemRefsKeys[nextIndex];

          target = this.itemRefs[nextItemRef];
          target.focus();
          break;

        // up arrow
        case 38:
          // on first item, can't go up
          if (activeIndex === 0) {
            return;
          }
          const prevIndex = activeIndex - 1;
          const prevItemRef = itemRefsKeys[prevIndex];

          target = this.itemRefs[prevItemRef];
          target.focus();
          break;

        // end btn (go to last item)
        case 35:
          const lastIndex = itemRefsKeys.length - 1;
          const lastItemRef = itemRefsKeys[lastIndex];

          target = this.itemRefs[lastItemRef];
          target.focus();
          break;

        // home btn (go to first item)
        case 36:
          const firstItemRef = itemRefsKeys[0];

          target = this.itemRefs[firstItemRef];
          target.focus();
          break;

        default:
          break;
    }
  }

  componentDidMount() {
    this.setRegionRefs(this.props);
  }

  componentDidUpdate(nextProps: Props) {
    this.setRegionRefs(nextProps);
  }

  setItemRef(ref: any, itemRef: string) {
    this.itemRefs[itemRef] = ref;
  }

  setRegionRefs(props: Props) {
    let refs = [];

    for(const area of props.resortList) {
        for (const state of area.states) {

          if (state.name !== "NO-STATE") {
            refs.push(state.name);
          }

          for (const resort of state.resorts) {
            refs.push(`${state.name}-${resort.resortId}`);
          }
        }
    }
  }

  renderDropdown = () => {
    return this.props.resortList.map(area => {
      const states = area.states.map((state: any) => {
        return (
          <ResortDropdownGroup
            key={state.name}
            limit={this.props.limit}
            onSelection={this.props.onSelect}
            onRemoval={this.props.onRemoval}
            name={state.name}
            group={state.resorts}
            selected={this.props.selected || []}
            keydown={this.keydown}
            setItemRef={this.setItemRef}
          ></ResortDropdownGroup>
        );
      });

      return (
        <ul key={`${area.continent}-${area.name}`} className="continent-group">
          <li className="single-continent">
            <span className="continent-title">{area.continent} - {area.name}</span>
            <ul className="cities" role="listbox">
              <li className="state-container">{states}</li>
            </ul>
          </li>
        </ul>
      );
    });
  };

  render() {
    return (
      <div className="dd-unselected-wrap">
          {this.renderDropdown()}
      </div>
    )
  }
}
export default ResortDropdownList;
